export const getTransformedElement = (element) => {
  const updatedRotation = [-90, 90, 270].includes(element.rotation());

  const offsetX = updatedRotation ? element.offsetY() : element.offsetX();
  const offsetY = updatedRotation ? element.offsetX() : element.offsetY();
  const width = updatedRotation ? element.height() : element.width();
  const height = updatedRotation ? element.width() : element.height();

  return {
    offsetX,
    offsetY,
    width,
    height,
  };
};
